import React, { FC } from 'react';
import { Size } from 'src/types';
import styled from 'styled-components';

interface CountryFlagProps {
  countryCode?: string | string[];
  size?: Size;
}

export const CountryFlag: FC<CountryFlagProps> = ({
  countryCode = 'NZ',
  size,
}) => {
  const flagUrl =
    'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg';

  if (typeof countryCode === 'string') {
    return (
      <Flag
        className="flag"
        src={flagUrl.replace('{XX}', countryCode)}
        size={size}
      />
    );
  } else if (Array.isArray(countryCode) && countryCode.length > 0) {
    return (
      <Flags className="flag">
        {countryCode.map((code, index) => (
          <ClippedFlag
            key={code}
            src={flagUrl.replace('{XX}', code)}
            size={size}
            index={index}
          />
        ))}
      </Flags>
    );
  } else {
    return null;
  }
};

const Flag = styled.img<CountryFlagProps>`
  width: calc(
    (${({ theme, size }) => theme?.size?.[size]?.width ?? '1em'}) * 1.5
  );
  height: ${({ theme, size }) => theme?.size?.[size]?.height ?? '1em'};
`;

const Flags = styled.div<CountryFlagProps>`
  width: calc(
    (${({ theme, size }) => theme?.size?.[size]?.width ?? '1em'}) * 1.5
  );
  height: ${({ theme, size }) => theme?.size?.[size]?.height ?? '1em'};

  img {
    position: absolute;
  }
`;

const ClippedFlag = styled(Flag)<{ index: number }>`
  clip-path: ${({ index }) =>
    index === 0
      ? 'polygon(0 95%,0 0,100% 0)'
      : 'polygon(0% 100%,100% 100%,100% 5%)'};
`;
